<!--
  AppBrandingCard.svelte — Branded header card for third-party app authorization flow.

  Displays the requesting application's logo (or icon, or generic cube),
  name, and description. Used on the Login, TwoFactor, and Authorize pages
  when the user is going through an external-app authentication flow.

  @prop {string} applicationName — The application's display name.
  @prop {string | null} description — Short description of the app.
  @prop {string | null} logoImageName — Filename of the app logo (uploads/applications/).
  @prop {string | null} iconImageName — Filename of the app icon (uploads/applications/).
  @prop {string | null} icon — CSS icon class (e.g. 'fa-cube') for fallback display.
-->
<script lang="ts">
	import site from '../site';
	import { t } from '../i18n';

	
	
	
	
	
	interface Props {
		/** The application's display name. */
		applicationName: string;
		/** Short description of the application. */
		description?: string | null;
		/** Filename for the application logo image. */
		logoImageName?: string | null;
		/** Filename for the application icon image. */
		iconImageName?: string | null;
		/** Font Awesome icon class for fallback display. */
		icon?: string | null;
	}

	let {
		applicationName,
		description = null,
		logoImageName = null,
		iconImageName = null,
		icon = null
	}: Props = $props();

	/** Base URL for building image paths. */
	const apiBase = site.backend.baseURL;
</script>

<div class="mb-6 border-b border-gray-200 pb-6 text-center dark:border-gray-700">
	{#if logoImageName}
		<img
			src="{apiBase}/uploads/applications/{logoImageName}"
			alt={applicationName}
			class="mx-auto mb-3 h-32 w-auto max-w-full object-contain dark:invert"
		/>
	{:else if iconImageName}
		<img
			src="{apiBase}/uploads/applications/{iconImageName}"
			alt={applicationName}
			class="mx-auto mb-3 h-14 w-14 rounded-lg object-contain dark:invert"
		/>
	{:else}
		<div
			class="mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-xl bg-primary-100 dark:bg-primary-900/30"
		>
			<i class="fa-solid {icon || 'fa-cube'} text-xl text-primary-600 dark:text-primary-400"></i>
		</div>
	{/if}

	{#if !logoImageName}
		<h3 class="text-lg font-semibold text-gray-900 dark:text-white">
			{applicationName}
		</h3>
	{/if}
	<p class="mt-1 text-sm text-gray-500 dark:text-gray-400">{$t("Enter your email to get started.")}</p>

	{#if description}
		<p class="mt-1 text-xs text-gray-400 dark:text-gray-500">
			{description}
		</p>
	{/if}
</div>
